import React from 'react';

const ProkrayaLanding = ({contact}) => {
  const handleChange = () => { 
    contact.current.scrollIntoView({ behavior: 'smooth' });

  }
  return (
    <div className="font-sans">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-2">
            {/* Logo */}
            <div className="flex items-center">
              <div className="flex items-center">
                
         
              </div>
            </div>
            
            {/* Navigation */}
           
            {/* CTA Button */}
            {/* <button
                 onClick={handleChange}
              className="text-white px-8 py-3 rounded-lg font-bold hover:opacity-90 transition-opacity text-lg"
                    style={{ backgroundColor: '#FF9500' }}>
              BOOK A DEMO
            </button> */}
             <img src="https://ik.imagekit.io/satfy9rkc/ptkcs/RantaiPRO.png" alt="RantaiPro logo" className='h-12' />
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="min-h-screen flex items-center relative" 
               style={{ backgroundColor: '#17a2b8' }}>
        <div className="max-w-7xl mx-auto pt-0 mt-0 px-4 sm:px-6 lg:px-12  w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* Left Content */}
            <div className="text-white space-y-6">
              <h1 className="text-5xl lg:text-4xl font-bold leading-tight text-white">
                A Complete End-to-End<br />
                Lifecycle of Procurement<br />
                and Supplier Management.
              </h1>
              
              <p className="text-xl lg:text-xl opacity-90 leading-relaxed max-w-3xl">
                Streamline your source to pay process with Prokraya's cutting-edge technology. 
                Increase efficiency and reduce costs with our seamless, automated solution.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <button
                 onClick={handleChange}
                  className="px-10 py-2 rounded-lg font-bold transition-colors text-xl"
                        style={{ backgroundColor: 'white', color: '#4ECDC4' }}>
                  REQUEST DEMO
                </button>
                
              </div>
            </div>
            
            {/* Right Dashboard Image */}
            <div className="relative flex justify-center lg:justify-end">
              <img 
                src="https://ik.imagekit.io/kqumni8l2/kcs-products/prokraya/HomeSlide.png?updatedAt=1751355102606" 
                alt="Prokraya Dashboard Interface"
                className="w-full max-w-2xl h-auto object-contain rounded-xl shadow-2xl"
              />
            </div>
          </div>
        </div>
        
       
      </section>
    </div>
  );
};

export default ProkrayaLanding;